import React, { useEffect } from 'react';
import { HeroSection } from './components/sections/HeroSection';
import { ProblemSection } from './components/sections/ProblemSection';
import { SolutionSection } from './components/sections/SolutionSection';
import { VolumesSection } from './components/sections/VolumesSection';
import { InsideCarouselSection } from './components/sections/InsideCarouselSection';
import { BonusesSection } from './components/sections/BonusesSection';
import { ValueSection } from './components/sections/ValueSection';
import { OfferSection } from './components/sections/OfferSection';
import { TestimonialsSection } from './components/sections/TestimonialsSection';
import { FaqSection } from './components/sections/FaqSection';
import { LastQuestionSection } from './components/sections/LastQuestionSection';
import { FinalCtaSection } from './components/sections/FinalCtaSection';
import { SiteFooter } from './components/SiteFooter';
import { PurchasePopup } from './components/PurchasePopup';
import { initMetaPixel, PIXEL_ID } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen w-full bg-black font-sans text-zinc-200 antialiased" data-id="element-0" data-mp="3mjzpgvevclx2">
      <noscript data-id="element-1" data-mp="3rdkl4gszp3t3">
        <img height="1" width="1" style={{
        display: 'none'
      }} alt="" src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-2" data-mp="3rd18nfm3z7mg" />
      </noscript>
      <div className="mx-auto w-full max-w-3xl bg-zinc-900 shadow-2xl shadow-cyan-950/40" data-id="element-3" data-mp="2zmeoiach9o8k">
        <HeroSection data-id="element-4" data-mp="33nq5jrhad155" />
        <main data-id="element-5" data-mp="33mym1f0yqtv8">
          <ProblemSection data-id="element-6" data-mp="33ork45xig5rm" />
          <SolutionSection data-id="element-7" data-mp="38m1fe27kzbnd" />
          <VolumesSection data-id="element-8" data-mp="38kqafz2efxuo" />
          <InsideCarouselSection data-id="element-9" data-mp="38kgmeh0x00rm" />
          <BonusesSection data-id="element-10" data-mp="3dkl42adk71jf" />
          <ValueSection data-id="element-11" data-mp="3dlw727z6k59h" />
          <OfferSection data-id="element-12" data-mp="3dmfozootytni" />
          <TestimonialsSection data-id="element-13" data-mp="3dii530ufhy2k" />
          <FaqSection data-id="element-14" data-mp="nw2e2bl1k0tq" />
          <LastQuestionSection data-id="element-15" data-mp="nur6e0oh68xc" />
          <FinalCtaSection data-id="element-16" data-mp="nxn5hsc273nd" />
        </main>
        <SiteFooter data-id="element-17" data-mp="stuejtzr4v9j" />
      </div>
      <PurchasePopup data-id="element-18" data-mp="st2iki28sviq" />
    </div>;
}